"use client";

import { useState } from "react";
import Image from "next/image";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";
import { SocialLink } from "~/components/icons/Social";

const testimonials = [
    {
        id: 1,
        name: "Tim Ferriss",
        role: "",
        image: "/home/testimonials/TimFerris-photo@2.png",
        text: "Last night, the platform River helped you all run parties around the world in more than 180 cities! More than 4,000 people RSVP'd. I was able to join about 40 cities via Zoom for quick hellos and drinks (huge thanks to Rae and Ana for the quarterbacking), and I had a blast visiting one in person in Paris. Thanks to everyone who gathered for wine, celebration, and meeting like-minded lovelies!",
        bgColor: "#D1E350",
        socialLinks: {
            twitter: "https://x.com/tferriss",
            instagram: "https://www.instagram.com/timferriss/",
            linkedin: "https://www.linkedin.com/in/timferriss/",
        },
    },
    {
        id: 2,
        name: "Jason Calacanis",
        role: "Founder Fridays",
        image: "/home/testimonials/Jason-photo@2.png",
        text: "River helps All-In & This Week in Startups discover and activate the top 1% of fans, which are worth 100x more to us. We've been trying to find a solution for this, and \"TEDx in a box\" didn't exist before. With River, 1 community manager can now do the work of 3-4 community managers.",
        bgColor: "#C9E9E9",
        socialLinks: {
            twitter: "https://x.com/Jason",
            instagram: "https://www.instagram.com/jason/",
            linkedin: "https://www.linkedin.com/in/jasoncalacanis/",
        },
    },
    {
        id: 3,
        name: "Bryan Johnson",
        role: "Don't Die",
        image: "/home/testimonials/BryanJohnson@2.png",
        text: "River helped us have more gatherings than I thought possible — with just a bit of promotion (a few tweets, instagram posts, and one email), we were able to have 300 meetups with 7,000 people!",
        bgColor: "#F8F5E9",
        socialLinks: {
            twitter: "http://x.com/bryan_johnson",
            instagram: "http://instagram.com/bryanjohnson_/",
            linkedin: "https://www.linkedin.com/in/bryanrjohnson/",
        },
    },
];

export default function TestimonialsCarousel() {
    const [current, setCurrent] = useState(0);
    const [direction, setDirection] = useState(0);

    const next = () => {
        setDirection(1);
        setCurrent((current + 1) % testimonials.length);
    };

    const prev = () => {
        setDirection(-1);
        setCurrent((current - 1 + testimonials.length) % testimonials.length);
    };

    return (
        <div className="relative mx-auto w-full max-w-6xl">
            <h2 className="mb-5 text-center text-2xl font-[400] text-white">
                What people sare saying about River
            </h2>
            <div className="relative flex items-center justify-center overflow-hidden">
                <div className="flex lg:-mx-32">
                    <div
                        className="z-10 flex min-h-[400px] w-full flex-col items-center gap-8 rounded-3xl p-6 transition-colors duration-500 lg:h-[360px] lg:w-[1060px] lg:flex-row lg:rounded-full"
                        style={{
                            backgroundColor: testimonials[current]?.bgColor,
                        }}
                    >
                        <div className="relative hidden h-[250px] w-[250px] flex-shrink-0 sm:block lg:h-[371px] lg:w-[335px]">
                            <Image
                                key={current}
                                src={testimonials[current]?.image || ""}
                                alt={testimonials[current]?.name || ""}
                                fill
                                className={`h-full w-full rounded-full object-cover transition-transform duration-500 ${
                                    direction > 0
                                        ? "animate-slideInRight"
                                        : "animate-slideInLeft"
                                }`}
                            />
                        </div>
                        <div
                            className={`flex min-h-[400px] flex-col justify-between text-center font-[500] text-[#121418] transition-transform duration-500 sm:justify-center lg:text-left ${
                                direction > 0
                                    ? "animate-slideInRight"
                                    : "animate-slideInLeft"
                            }`}
                        >
                            <p className="mb-4 w-full px-4 text-center text-base leading-relaxed sm:px-0 lg:max-w-[90%] lg:text-left lg:text-lg">
                                “{testimonials[current]?.text}”
                            </p>
                            <div className="flex items-center gap-2 px-8">
                                <span className="sm:hidden">
                                    <div className="relative h-12 w-12 overflow-hidden rounded-full">
                                        <Image
                                            key={current}
                                            src={
                                                testimonials[current]?.image ||
                                                ""
                                            }
                                            alt={
                                                testimonials[current]?.name ||
                                                ""
                                            }
                                            fill
                                            className="object-cover"
                                        />
                                    </div>
                                </span>
                                <div className="flex w-full flex-col items-start justify-center sm:text-center">
                                    <h3 className="text-[24px]">
                                        {testimonials[current]?.name}
                                    </h3>
                                    <p className="text-v3-N-400">
                                        {testimonials[current]?.role}
                                    </p>
                                    <ul className="flex gap-2">
                                        {Object.entries(
                                            testimonials[current]!.socialLinks,
                                        ).map(([key, value]) => {
                                            if (!value) return null;
                                            return (
                                                <li key={key}>
                                                    <SocialLink
                                                        href={value}
                                                        className="h-6 w-6"
                                                    />
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    onClick={prev}
                    className="absolute bottom-10 left-2 z-20 rounded-full bg-v3-N-500 p-2 hover:bg-v3-N-500/80 sm:bottom-auto lg:left-0"
                >
                    <LuChevronLeft className="h-6 w-6" />
                </button>

                <button
                    onClick={next}
                    className="absolute bottom-10 right-2 z-20 rounded-full bg-v3-N-500 p-2 hover:bg-v3-N-500/80 sm:bottom-auto lg:right-0"
                >
                    <LuChevronRight className="h-6 w-6" />
                </button>
            </div>

            <div className="mt-4 flex justify-center gap-2">
                {testimonials.map((_, index) => (
                    <button
                        key={index}
                        className={`h-2 rounded-full transition-all duration-300 ${
                            current === index
                                ? "w-8 bg-v3-primary"
                                : "w-2 bg-v3-N-400"
                        }`}
                        onClick={() => {
                            setDirection(index > current ? 1 : -1);
                            setCurrent(index);
                        }}
                    />
                ))}
            </div>
        </div>
    );
}
